import {
  FileText,
  PanelsTopLeft,
  NotebookPen,
  Sparkles,
  type LucideIcon,
} from 'lucide-react'

import type { DocumentType } from './types'

export const DOCUMENT_TYPES: Record<
  DocumentType,
  { label: string; icon: LucideIcon; colorClass: string }
> = {
  general: {
    label: 'General',
    icon: FileText,
    colorClass: 'text-primary-solid',
  },
  template: {
    label: 'Template',
    icon: PanelsTopLeft,
    colorClass: 'text-hanna-solid',
  },
  note: { label: 'Note', icon: NotebookPen, colorClass: 'text-angelica-solid' },
  prompt: { label: 'Prompt', icon: Sparkles, colorClass: 'text-david-solid' },
}

export const DOCUMENT_TYPE_ORDER: DocumentType[] = [
  'general',
  'template',
  'note',
  'prompt',
]

export const DEFAULT_DOCUMENT_TYPE: DocumentType = 'general'
